import {createFragmentContainer, graphql} from 'react-relay';
import React from 'react';
import {useIntl} from 'react-intl';
import {FlexColumn, Heading, Table} from '@forecast-it/design-system';
import {BUDGET_TYPE} from '../../../../constants';

const ProjectInvoicingFixedPriceDeliverablesSection = ({project, company}) => {
	const {formatMessage} = useIntl();
	const currency = project.rateCard?.currency || company.currency;

	const rows = (project.deliverables?.edges || [])
		.map(edge => edge.node)
		.filter(deliverable => project.budgetType === BUDGET_TYPE.TIME_AND_MATERIALS && deliverable.price != null)
		.map(deliverable => ({
			id: deliverable.id,
			name: deliverable.name,
			price: deliverable.price,
			invoicedAmount: deliverable.invoicedAmount,
			remainingToInvoice: deliverable.price - deliverable.invoicedAmount,
		}));

	if (rows.length === 0) {
		return null;
	}

	return (
		<FlexColumn flex={'0 0 auto'} gap={'xl'} data-cy={'fixed-price-deliverables-invoicing-section'}>
			<Heading>{formatMessage({id: 'invoicing.fixed_price_deliverables'})}</Heading>
			<Table data={rows} width={'100%'} data-cy={'fixed-price-deliverables-table'}>
				<Table.TextColumn accessorKey={'name'} header={formatMessage({id: 'common.deliverable'})} />
				<Table.CurrencyColumn
					accessorKey={'price'}
					header={formatMessage({id: 'invoicing.fixed_price_deliverables.fixed_fee'})}
					currency={currency}
				/>
				<Table.CurrencyColumn
					accessorKey={'invoicedAmount'}
					header={formatMessage({id: 'common.invoiced'})}
					currency={currency}
					data-cy={'fixed-price-deliverable-invoiced'}
				/>
				<Table.CurrencyColumn
					accessorKey={'remainingToInvoice'}
					header={formatMessage({id: 'invoicing.fixed_price_deliverables.remaining_to_invoice'})}
					currency={currency}
					data-cy={'fixed-price-deliverable-remaining'}
				/>
			</Table>
		</FlexColumn>
	);
};

export default createFragmentContainer(ProjectInvoicingFixedPriceDeliverablesSection, {
	project: graphql`
		fragment ProjectInvoicingFixedPriceDeliverablesSection_project on ProjectType {
			id
			budgetType
			rateCard {
				currency
			}
			deliverables(first: 10000) {
				edges {
					node {
						id
						name
						price
						invoicedAmount
					}
				}
			}
		}
	`,
});
